var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"passport"},[_c('div',{staticClass:"container"},[_c('img',{staticClass:"left-pic",attrs:{"src":require("@/assets/images/login_pic.png")}}),_c('div',{staticClass:"wrap"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }